<template>
  <input
    class="tc-checkbox-native"
    type="checkbox"
    ref="checkbox"
    @change="toggleValue"
    :disabled="disabled"
    :checked="value === true"
    role="checkbox"
    :aria-checked="value === null ? 'mixed' : value"
    :aria-label="i18nAriaLabel"
  />
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: null,
    },
    i18nAriaLabel: {
      type: String,
      default: () => 'defaultSwitchAriaLabel',
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  mounted() {
    if (this.disabled) {
      this.$refs.checkbox.checked = true;
    }
    if (this.value === null) {
      this.$refs.checkbox.indeterminate = true;
    }
  },
  watch: {
    value: function(newVal) {
      this.$refs.checkbox.indeterminate = newVal === null;
    },
  },
  methods: {
    toggleValue() {
      if (this.disabled) {
        return;
      }
      if (this.value === null) {
        this.$emit('input', false);
      } else {
        this.$emit('input', !this.value);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tc-checkbox-native {
  margin: 0;
}
</style>
